import { render, staticRenderFns } from "./BaseTitleBar.vue?vue&type=template&id=89e91e68&scoped=true"
import script from "./BaseTitleBar.vue?vue&type=script&lang=js"
export * from "./BaseTitleBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e91e68",
  null
  
)

export default component.exports